import { Outlet, Navigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import { useTranslation } from 'react-i18next'
import { useTheme } from '../contexts/ThemeContext'
import './AuthLayout.css'

export default function AuthLayout() {
    const { isAuthenticated } = useAuthStore()
    const { i18n } = useTranslation()
    const { theme, toggleTheme } = useTheme()

    // Redirect if already authenticated
    if (isAuthenticated) {
        return <Navigate to="/dashboard" replace />
    }

    return (
        <div className="auth-layout">
            <div className="auth-background">
                <div className="auth-gradient-1"></div>
                <div className="auth-gradient-2"></div>
                <div className="auth-grid"></div>
            </div>

            <div className="auth-header-actions">
                <button
                    onClick={() => {
                        const newLang = i18n.language === 'fr' ? 'en' : 'fr';
                        i18n.changeLanguage(newLang);
                    }}
                    className="auth-icon-btn"
                    title="Change Language"
                >
                    {i18n.language === 'fr' ? 'EN' : 'FR'}
                </button>
                <button
                    onClick={toggleTheme}
                    className="auth-icon-btn"
                    title="Toggle Theme"
                >
                    <SunOrMoon theme={theme} />
                </button>
            </div>

            <div className="auth-container">
                <div className="auth-card">
                    <div className="auth-logo">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                            <line x1="16" y1="2" x2="16" y2="6" />
                            <line x1="8" y1="2" x2="8" y2="6" />
                            <line x1="3" y1="10" x2="21" y2="10" />
                            <path d="m9 16 2 2 4-4" />
                        </svg>
                        <span className="auth-logo-text">Star-Dev Agenda</span>
                    </div>

                    <Outlet />
                </div>

                <div className="auth-footer">
                    <p>© 2024 Star-Dev. Tous droits réservés.</p>
                </div>
            </div>
        </div>
    )
}

function SunOrMoon({ theme }) {
    if (theme === 'dark') {
        return (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="5"></circle>
                <line x1="12" y1="1" x2="12" y2="3"></line>
                <line x1="12" y1="21" x2="12" y2="23"></line>
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                <line x1="1" y1="12" x2="3" y2="12"></line>
                <line x1="21" y1="12" x2="23" y2="12"></line>
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
            </svg>
        )
    }
    return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
        </svg>
    )
}
